import getFirebase from "../api/firebase";

interface AnalyticsEventParams {
  [key: string]: string | number | boolean | undefined | object[];
}

interface PurchaseItem {
  item_name: string;
  quantity: number;
  price: number;
}

// Safe analytics logging - no-op on localhost
const logEvent = async (eventName: string, params: AnalyticsEventParams = {}): Promise<void> => {
  if (window.location.hostname === "localhost") {
    console.log("[Analytics]", eventName, params);
    return;
  }

  try {
    const firebase = await getFirebase();
    firebase.analytics().logEvent(eventName, params);
  } catch (error) {
    console.error("[Analytics] Failed to log event:", error);
  }
};

// Funnel events
export const trackStartProduct = (productType: string): void => {
  logEvent("begin_checkout", {
    product_type: productType,
    step: "start",
  });
};

export const trackUploadComplete = (productType: string, photoCount: number): void => {
  logEvent("upload_complete", {
    product_type: productType,
    photo_count: photoCount,
    step: "upload",
  });
};

export const trackSettingsComplete = (productType: string): void => {
  logEvent("settings_complete", {
    product_type: productType,
    step: "settings",
  });
};

export const trackCustomizationComplete = (productType: string, pageCount: number): void => {
  logEvent("customization_complete", {
    product_type: productType,
    page_count: pageCount,
    step: "customize",
  });
};

export const trackPurchase = (productType: string, value: number): void => {
  const items: PurchaseItem[] = [{ item_name: productType, quantity: 1, price: value }];
  logEvent("purchase", {
    currency: "DZD",
    value: value,
    product_type: productType,
    items: items,
  });
};

// Additional useful events
export const trackLogin = (method: string): void => {
  logEvent("login", { method });
};

export const trackSignUp = (method: string): void => {
  logEvent("sign_up", { method });
};

export const trackPhotoUpload = (count: number): void => {
  logEvent("upload_photo", { count });
};

export const trackError = (errorType: string, errorMessage: string): void => {
  logEvent("error", {
    error_type: errorType,
    error_message: errorMessage,
  });
};
